import { createContext } from 'react';

export const PusherContext = createContext(undefined);

export default PusherContext;
